import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    // If returning from Google OAuth, AuthCallback exchanges the session_id first
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only session check; api is a stable module import
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.error("Logout request failed:", e);
    }
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
